//1.导入VueRouter
import store from '@/store'
import VueRouter from 'vue-router'
import {routerList} from './router'
import prototype from '@/utils/prototype'
const router = new VueRouter({
    
    routes: routerList,
    // 路由滚动行为
    scrollBehavior: () => {
        return { x: 0, y: 0 }
    },
    mode:'history'


})

let originPush = VueRouter.prototype.push
let originReplace = VueRouter.prototype.replace

VueRouter.prototype.push = function (location, resolve, reject) {
    if (resolve && reject) {
       
        originPush.call(this, location, resolve, reject)
    } else {
        originPush.call(this, location, () => { }, () => { })
    }
}
VueRouter.prototype.replace = function (location, resolve, reject) {
    if (resolve && reject) {
        originReplace.call(this, location, resolve, reject)
    } else {
        originReplace.call(this, location, () => { }, () => { })
    }
}


router.beforeEach((to,from,next)=>{
  
    if(to.path.includes('/product/productHome/')){
        
            // console.log(to.meta.id)
            prototype.debounce(function() {
                store.dispatch('product/getProduct',to.meta.id)
            }, 100)
     
    }
    next()
})
export default router